import React, { ChangeEvent, useState } from 'react';
import { Button, Divider, Form, Input, Select, message } from 'antd';

import { usePageData } from '../../hooks/usePage';
import { useGetUser } from '../../hooks/useGetUser';

import { IPageData } from '../../interfaces/page';
import seguridadProvider from '../../services/seguridadProvider';

const pageData: IPageData = {
  title: 'Editar Cuenta',
  fulFilled: true,
  breadcrumbs: [
    {
      title: 'Inicio',
      route: 'default-dashboard'
    },
    {
      title: 'Administración',
      route: 'default-dashboard'
    },
    {
      title: 'Editar cuenta'
    }
  ]
};

const FormItem = Form.Item;

const PasswordForm = () => {
  const [form] = Form.useForm();
  const onHandleCambiarClave = async (val) => {
    const res :any = await seguridadProvider.cambiarContrasena(val);
    if (res == -1) message.warning('La clave actual no es valida');
    else message.success('Se realizo el cambio de clave, cierre su sesión y vuelva a ingresar');
    form.resetFields();
  };
  return (
    <Form form={form} layout='vertical' onFinish={onHandleCambiarClave}>
      <FormItem name='Psw' label='Clave actual'>
        <Input.Password placeholder='Clave actual' />
      </FormItem>
      <div className='row'>
        <div className='col-md-6 col-sm-12'>
          <FormItem
            name='PswNuevo'
            label='Clave nueva'
            rules={[{ required: true, message: 'Ingrese una nueva clave' }]}
          >
            <Input.Password placeholder='Nueva clave' />
          </FormItem>
        </div>

        <div className='col-md-6 col-sm-12'>
          <FormItem
            name='confirmPassword'
            label='Confirmar clave nueva'
            rules={[
              {
                required: true,
                message: 'Confirme su nueva clave!'
              },
              ({ getFieldValue }) => ({
                validator(rule, value) {
                  if (!value || getFieldValue('PswNuevo') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject('La nueva clave no coinciden!');
                }
              })
            ]}
          >
            <Input.Password placeholder='Confirmar clave nueva' />
          </FormItem>
        </div>
      </div>

      <Button htmlType={'submit'} type='primary'>Cambiar clave</Button>
    </Form>
  );
};

const EditAccountPage = () => {
  const user = useGetUser();
  usePageData(pageData);
  return (
    <div className='stack' style={{ maxWidth: 690, margin: '0 auto' }}>
      <PasswordForm />
    </div>
  );
};

export default EditAccountPage;
